var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 1.72054L12.9999 16.283C12.9994 16.6071 12.9073 16.9245 12.7343 17.1985C12.5613 17.4726 12.3143 17.6922 12.0219 17.832C11.7295 17.9718 11.4036 18.0262 11.0817 17.9888C10.7597 17.9514 10.4549 17.8239 10.2023 17.6208L1.17708 10.3396C0.977279 10.1785 0.816084 9.97476 0.705339 9.74327C0.594593 9.51177 0.537109 9.25841 0.537109 9.00178C0.537109 8.74516 0.594593 8.4918 0.705339 8.2603C0.816084 8.0288 0.977279 7.82505 1.17708 7.66402L10.2029 0.382776C10.4554 0.179299 10.7604 0.0513328 11.0825 0.0136251C11.4046 -0.0240826 11.7309 0.0300036 12.0236 0.16965C12.3159 0.309902 12.5627 0.529905 12.7354 0.804299C12.9081 1.07869 12.9998 1.39631 12.9999 1.72054Z",
    fill: "#100C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.61bdfcfda9600b8bc21389269a67af93.svg";
export { ForwardRef as ReactComponent };